/**
 * v-auth
 * 按钮权限指令
 */
import type { Directive, DirectiveBinding } from "vue";
import { useUserStore } from "@/stores/modules/user";

const auth: Directive = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        const { value } = binding;
        const userStore = useUserStore();
        const permissions = userStore.userInfo.permissions;
        if (value instanceof Array && value.length) {
            // 此处判断为权限包含任意一项即可允许
            const hasPermission = value.some(item => permissions.includes(item));
            if (!hasPermission) {
                el.style.display = "none";
            }
        } else {
            if (!permissions.includes(value)) {
                el.style.display = "none";
            }
        }
    }
};

export default auth;
